module.exports = __webpack_public_path__ + "img/product-default.d5ae81a5.png";